import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
};

const parkitNavSlice = createSlice({
  name: 'parkitNav',
  initialState,
  reducers: {
    openParkitNav: (state) => {
      state.open = true;
    },
    closeParkitNav: (state) => {
      state.open = false;
    },
  },
});

export const selectState = state => state.parkitNav;
export const { openParkitNav, closeParkitNav } = parkitNavSlice.actions;
export default parkitNavSlice.reducer;